var map = {
	"./001-thumb up.svg": 382,
	"./002-battery charge.svg": 383,
	"./003-flashlight.svg": 384,
	"./004-microphone.svg": 385,
	"./005-information.svg": 386,
	"./006-cogwheel.svg": 387,
	"./007-app.svg": 388,
	"./007-microphone-1.png": 389,
	"./008-bell.svg": 390,
	"./009-camera.svg": 391,
	"./010-app.svg": 392,
	"./010-home.png": 393,
	"./011-asterisk.svg": 394,
	"./012-brightness.svg": 395,
	"./013-backward.svg": 396,
	"./013-document-1.png": 397,
	"./014-document.png": 398,
	"./014-empty battery.svg": 399,
	"./015-color-palette.png": 400,
	"./015-full battery.svg": 401,
	"./016-bolt.svg": 402,
	"./017-book.svg": 403,
	"./017-video-camera.png": 404,
	"./018-bookmark.svg": 405,
	"./019-briefcase.svg": 406,
	"./020-bug.svg": 407,
	"./021-building.svg": 408,
	"./022-calculator.svg": 409,
	"./023-calendar.svg": 410,
	"./024-car.svg": 411,
	"./024-like.svg": 412,
	"./025-comment.svg": 413,
	"./026-chat.svg": 414,
	"./027-conversation.svg": 415,
	"./028-check.svg": 416,
	"./029-clipboard.svg": 417,
	"./030-clock.svg": 418,
	"./031-cloud.svg": 419,
	"./032-cup.svg": 420,
	"./033-computer.svg": 421,
	"./034-copy.svg": 422,
	"./035-credit card.svg": 423,
	"./036-cross.svg": 424,
	"./037-cube.svg": 425,
	"./038-dashboard.svg": 426,
	"./039-backspace.svg": 427,
	"./040-down.svg": 428,
	"./041-download.svg": 429,
	"./042-spoon and fork.svg": 430,
	"./043-edit.svg": 431,
	"./044-envelope.svg": 432,
	"./045-exclamation mark.svg": 433,
	"./046-flag.svg": 434,
	"./047-folder.svg": 435,
	"./048-forbidden.svg": 436,
	"./049-forward.svg": 437,
	"./050-glass.svg": 438,
	"./051-home.svg": 439,
	"./052-hot.svg": 440,
	"./053-Hotspot.svg": 441,
	"./054-hourglass.svg": 442,
	"./055-image.svg": 443,
	"./056-keyboard.svg": 444,
	"./057-left.svg": 445,
	"./058-lifebuoy.svg": 446,
	"./059-location.svg": 447,
	"./060-love.svg": 448,
	"./061-search.svg": 449,
	"./062-minus.svg": 450,
	"./063-money.svg": 451,
	"./064-music note.svg": 452,
	"./065-new-document.svg": 453,
	"./066-news.svg": 454,
	"./067-no battery.svg": 455,
	"./068-bell.svg": 456,
	"./069-no camera.svg": 457,
	"./070-cloud.svg": 458,
	"./071-computer.svg": 459,
	"./072-folder.svg": 460,
	"./073-hourglass.svg": 461,
	"./074-image.svg": 462,
	"./075-keyboard.svg": 463,
	"./076-microphone.svg": 464,
	"./077-no money.svg": 465,
	"./078-padlock.svg": 466,
	"./079-printer.svg": 467,
	"./080-recycle bin.svg": 468,
	"./081-no smartphones.svg": 469,
	"./082-no sound.svg": 470,
	"./083-no video.svg": 471,
	"./084-vision.svg": 472,
	"./085-no wifi.svg": 473,
	"./086-options.svg": 474,
	"./087-padlock.svg": 475,
	"./088-send.svg": 476,
	"./089-pause.svg": 477,
	"./090-airplane.svg": 478,
	"./091-play button.svg": 479,
	"./092-plugin.svg": 480,
	"./093-add button.svg": 481,
	"./094-printer.svg": 482,
	"./095-puzzle.svg": 483,
	"./096-question mark.svg": 484,
	"./097-recycle bin.svg": 485,
	"./098-right button.svg": 486,
	"./099-save.svg": 487,
	"./100-search-file.svg": 488,
	"./101-share.svg": 489,
	"./102-shield.svg": 490,
	"./103-shield.svg": 491,
	"./104-shopping bag.svg": 492,
	"./105-shopping cart.svg": 493,
	"./106-smartphone.svg": 494,
	"./107-smartphone.svg": 495,
	"./108-smartphone.svg": 496,
	"./109-sort.svg": 497,
	"./110-sound.svg": 498,
	"./111-medium volume.svg": 499,
	"./112-mute.svg": 500,
	"./113-low volume.svg": 501,
	"./114-high volume.svg": 502,
	"./115-star.svg": 503,
	"./116-stop button.svg": 504,
	"./117-sun.svg": 505,
	"./118-telephone.svg": 506,
	"./119-television.svg": 507,
	"./120-thumb down.svg": 508,
	"./121-tool.svg": 509,
	"./122-umbrella.svg": 510,
	"./123-up arrow.svg": 511,
	"./124-upload.svg": 512,
	"./125-user.svg": 513,
	"./126-users.svg": 514,
	"./127-video-camera.svg": 515,
	"./128-vision.svg": 516,
	"./129-wallet.svg": 517,
	"./130-warning.svg": 518,
	"./131-water drop.svg": 519,
	"./132-wifi.svg": 520,
	"./133-world.svg": 521,
	"./134-zoom in.svg": 522,
	"./135-zoom out.svg": 523,
	"./136-eye.svg": 524,
	"./155-credit-card.svg": 525,
	"./New Customer.svg": 526,
	"./NotOpen.svg": 527,
	"./Opened.svg": 528,
	"./Profit.svg": 529,
	"./SalesRevenue.svg": 530,
	"./Sent.svg": 531,
	"./Slack.svg": 532,
	"./address.svg": 533,
	"./adobe.svg": 534,
	"./arrow-left.svg": 318,
	"./arrow-right.svg": 319,
	"./barcode.svg": 535,
	"./barcode_search.svg": 536,
	"./book.svg": 537,
	"./camera.svg": 538,
	"./chat.svg": 539,
	"./clipboard.svg": 540,
	"./cloud.svg": 541,
	"./columns.svg": 542,
	"./documentation.svg": 543,
	"./file.svg": 544,
	"./flat.svg": 545,
	"./headphone.svg": 546,
	"./iconfinder_trello_2317760.svg": 547,
	"./idea.svg": 548,
	"./image.png": 549,
	"./image.svg": 550,
	"./label.png": 551,
	"./layers.svg": 552,
	"./left.svg": 553,
	"./logo2.svg": 554,
	"./logo3.svg": 555,
	"./logo4.svg": 556,
	"./logo5.svg": 557,
	"./logo6.svg": 558,
	"./logoIn.svg": 559,
	"./paint.svg": 560,
	"./protection.svg": 561,
	"./quote.png": 562,
	"./repeat.svg": 563,
	"./right.svg": 323,
	"./strategy.svg": 564,
	"./theme.svg": 565,
	"./user.svg": 566,
	"./water-fall.svg": 567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;